module.exports = __webpack_public_path__ + "img/OBJECTS.5899abfa.svg";